import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { MemberNumberFormControl } from './member-number-form-control';

@Component({
  standalone: false,
  selector: 'app-member-number-form-control',
  templateUrl: './member-number-form-control.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MemberNumberFormControlComponent),
      multi: true
    }
  ]
})
export class MemberNumberFormControlComponent
  extends AbstractFormControlComponent<MemberNumberFormControl>
  implements ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  @Output() onChanged: EventEmitter<any> = new EventEmitter();

  faCheck: any = faCheck;
  faClose: any = faTimes;
  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  change(): void {
    this.onChanged.emit(this.control.value);
  }

  public get readOnlyCss(): boolean {
    return this.control.readOnlyCss || false;
  }
}
